export default function(state={}, action){
    switch(action.type){
        case "COPY_NODES":
            return {
                copiedNodes:action.nodes,
                copiedLinks:action.links,
                copiedLinkMap:action.linkMap
            };
        default:
            return state;
    }
}